import { $win, $body } from '../utils/globals';
import isMobile from '../utils/isMobile';

$('.js-footer-nav .menu__item--has-dropdown').on('touchstart', function () {
  const $this = $(this);
  if (isMobile.any()) {
    $this.toggleClass('is-expanded').siblings().removeClass('is-expanded');
  }
});
